export const SECTION_TITLE_SPECS = 'Specifications';
export const CHECKBOX_SECTION_DESC = 'Click on Model to view specifications';
export const BUTTON_TEXT_DOWNLOAD_BROCHURE = 'Download Brochure';
export const ERROR_MESSAGE = 'Specifications and features listed here are updated regularly, but may differ from actual vehicle and other sources (eg. brochures, websites). Please contact the dealer for the most up to date information.'; // @suppress longLineCheck
